export const INITIALIZE_SCENE_DATA = 'INITIALIZE_SCENE_DATA';
export const SET_PRODUCT_OPTION = 'SET_PRODUCT_OPTION';
export const DELETE_PRODUCT_OPTION = 'DELETE_PRODUCT_OPTION';
export const SET_SCENE_URI = 'SET_SCENE_URL';
export const DELETE_SCENE_TYPE = 'DELETE_SCENE_TYPE';
export const SET_SCENE_DESCRIPTION = 'SET_SCENE_DESCRIPTION';
export const SET_SCENE_ASPECT_RATIO = 'SET_SCENE_ASPECT_RATIO';
export const ADD_SCENE_TYPE = 'ADD_SCENE_TYPE';
